import isEmpty from 'lodash.isempty'

import { ROUTES } from '@router'

export const BACKMARKET_ID = '1458344336'

// The smart banner is displayed on the following routes
export const WHITELISTED_ROUTE = [
  ROUTES.HOME,
  ROUTES.PRODUCT.HOME,
  ROUTES.LANDING.PRODUCT,
]

export const trackingContext = ({ $route, $store }) => {
  const { name, params = {} } = $route
  if (ROUTES.PRODUCT.HOME === name) return params.id
  if (ROUTES.LANDING.PRODUCT === name) return $store.landingId

  return ''
}

export const trackingLink = ({
  linkPattern,
  country,
  deepLink = '',
  route = 'unknown',
  context = '',
}) => {
  if (isEmpty(country) || isEmpty(linkPattern)) {
    return undefined
  }
  const lowercaseCountry = country.toLowerCase()
  const pathParams = []
  let link = linkPattern
    .replace('{COUNTRY}', lowercaseCountry)
    .replace('{ROUTE}', route)

  if (!isEmpty(deepLink)) pathParams.push(`$deeplink_path=${deepLink}`)
  if (!isEmpty(context)) pathParams.push(`~placement_id=${context}`)
  if (!isEmpty(pathParams)) {
    const separator = linkPattern.includes('?') ? '&' : '?'
    link = `${link}${separator}${pathParams.join('&')}`
  }

  return link
}

export const iosSmartBannerMetadata = ({ deepLink }) => {
  const appArgument = !isEmpty(deepLink) ? `,app-argument=${deepLink}` : ''

  return {
    name: 'apple-itunes-app',
    content: `app-id=${BACKMARKET_ID}${appArgument}`,
  }
}

export const metadataWithSmartBanner = ({ deepLink = '', metadata = {} }) => {
  const meta = metadata.meta || []

  return {
    ...metadata,
    meta: [
      ...meta,
      iosSmartBannerMetadata({
        deepLink,
      }),
    ],
  }
}
